// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"6465daa2","71":"290e2e4a","73":"f6d34c2b","488":"2aa20054","580":"903ae3c2","787":"9a048472","866":"23532ce1"}[chunkId] + ".chunk.js";
};